import A11yDialog from "a11y-dialog";

$(function() {
  if ( $('img.should-crop') ) {
    new CropImage();
  }
});

class CropImage {
  constructor() {
    this.imageRatio = $('.should-crop').data('ratio');
    this.selectedCoordinates = this.calculateSelection();

    $(document).on('click', '.crop-guide-image', this.showModal.bind(this));
  }

  showModal(event) {
    event.preventDefault();
    
    const dialogElement = document.querySelector('#guide-crop-current-modal');
    
    this.dialog = new A11yDialog(dialogElement);
    this.dialog.show();

    var ratio = this.imageRatio;

    $('.should-crop').Jcrop({
      onChange: function(coords) {
        $(".crop_x").val(Math.floor(coords.x * ratio));
        $(".crop_y").val(Math.floor(coords.y * ratio));
        $(".crop_w").val(Math.floor(coords.w * ratio));
        $(".crop_h").val(Math.floor(coords.h * ratio));
      },
      bgColor: 'black',
      bgOpacity: .4,
      setSelect: this.selectedCoordinates,
      minSize: [200, 150],
      aspectRatio: 4 / 3
    });
  }

  calculateSelection() {
    return [
      $('.crop_x').val() ? ($('.crop_x').val() / this.imageRatio) : 0,
      $('.crop_y').val() ? ($('.crop_y').val() / this.imageRatio) : 0,
      $('.crop_w').val() ? ($('.crop_x').val() / this.imageRatio) + ($('.crop_w').val() / this.imageRatio) : 200,
      $('.crop_h').val() ? ($('.crop_y').val() / this.imageRatio) + ($('.crop_h').val() / this.imageRatio) : 150
    ];
  }
}
